import request from '@/utils/request'

let UserApi = {

  /*用户登录*/
  login (data, errorback) {
    return request._post('/shop/passport/login', data, errorback);
  },
  saasLogin (data, errorback) {
    return request._post('/shop/passport/saasLogin', data, errorback);
  },
  /*退出登录*/
  loginOut (data, errorback) {
    return request._post('/shop/passport/logout', data, errorback);
  },
  /*添加用户*/
  adduser (data, errorback) {
    return request._post('/shop/user/user/add', data, errorback);
  },
  /*修改用户*/
  edituser (data, errorback) {
    return request._postBody('/shop/user/user/edit', data, errorback);
  },
  /*修改用户手机号*/
  editTel (data, errorback) {
    return request._postBody('/shop/user/user/editTel', data, errorback);
  },

  /*充值*/
  userRecharge (data, errorback) {
    return request._postBody('/shop/user/user/recharge', data, errorback);
  },
  /*删除用户*/
  deleteuser (data, errorback) {
    return request._post('/shop/user/user/delete', data, errorback);
  },
  /*用户列表*/
  userlist (data, errorback) {
    return request._postBody('/shop/user/user/index', data, errorback);
  },
  /*团长列表*/
  grouplist (data, errorback) {
    return request._postBody('/shop/user/group/index', data, errorback);
  },
  /*团长分销订单列表*/
  groupOrderlist (data, errorback) {
    return request._postBody('/shop/user/group/order', data, errorback);
  },
  /*团长分销订单列表*/
  groupUserlist (data, errorback) {
    return request._postBody('/shop/user/group/user', data, errorback);
  },
  //结算
  finishOrder (data, errorback) {
    return request._post('/shop/user/group/finish', data, errorback);
  },
  /*团长分销订单导出*/
  exportUserOrderList(data,errorback) {
    console.log("ddddddddddddd--------",data)
      return request._get('/shop/user/group/export/'+data.ids, errorback);
  },
  /*等级列表*/
  gradelist (data, errorback) {
    return request._postBody('/shop/user/grade/index', data, errorback);
  },
  /*等级列表*/
  gradelog (data, errorback) {
    return request._postBody('/shop/user/grade/log', data, errorback);
  },
  /*添加等级*/
  addgrade (data, errorback) {
    return request._postBody('/shop/user/grade/add', data, errorback);
  },
  /*修改等级*/
  editGrade (data, errorback) {
    return request._postBody('/shop/user/grade/edit', data, errorback);
  },
  /*删除等级*/
  deletegrade (data, errorback) {
    return request._postBody('/shop/user/grade/delete', data, errorback);
  },
  /*用户余额*/
  BalanceLog (data, errorback) {
    return request._postBody('/shop/user/balance/log', data, errorback);
  },
  /*修改密码*/
  EditPass (data, errorback) {
    return request._post('/shop/passport/editPass', data, errorback);
  },
  /*用户标签*/
  toEditTag (data, errorback) {
    return request._get('/shop/user/user/toEditTag', data, errorback);
  },
  /*用户标签*/
  editTag (data, errorback) {
    return request._postBody('/shop/user/user/editTag', data, errorback);
  },
}

export default UserApi;



// WEBPACK FOOTER //
// ./src/api/user.js